import React from 'react';
import { Box, Icon, RowItem, Title1 } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import AutosFeedsBreadcrumbs from '../Breadcrumbs/AutosBreadcrumbs';
import AutosFeedsList from './AutosFeedsList';

import Classes from './AutosFeeds.module.scss';

export const AutosFeeds: React.FC = () => {
  const { t } = useI18nContext();
  return (
    <Box as="div" name="autosFeeds" className={Classes.autosFeeds}>
      <AutosFeedsBreadcrumbs />
      <Box as="div" name="titleContainer" className={Classes.titleContainer}>
        <Title1 className={Classes.title}>{t('homepage.exploreMore.title')}</Title1>
        <RowItem title={t('homepage.exploreMore.subtitle')} leftIcon={<Icon name="lightbulb" />} />
      </Box>
      <AutosFeedsList />
    </Box>
  );
};
